import React from 'react'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import { downloadPDF } from '../../_global/js/Utils.js';
import { ExportMail, ExportPrint } from '../../SVGs/svg.imports.js';


const SummaryActions = () => {
  const { matrixData, setCurrentId, summarySaveFunctionsReady, setShowEmailModal, pdfLink, resetQuestionLog, resetAnswerLog, resetPageLog, setSummarySaveFunctionsReady } = useStore(state =>({
    matrixData: state.matrixData,  
    setCurrentId: state.setCurrentId,
    summarySaveFunctionsReady: state.summarySaveFunctionsReady,
    setShowEmailModal: state.setShowEmailModal,
    pdfLink: state.pdfLink,
    resetQuestionLog: state.resetQuestionLog,
    resetAnswerLog: state.resetAnswerLog,
    resetPageLog: state.resetPageLog,
    setSummarySaveFunctionsReady: state.setSummarySaveFunctionsReady
  }), shallow);

  const printAndEmailReady = !summarySaveFunctionsReady ? true : false;
  
  const backToStart = () => {
    setCurrentId(matrixData['startPage']);
    resetQuestionLog();
    resetAnswerLog();
    resetPageLog();
    setSummarySaveFunctionsReady(false);
  }

  const printThisPage = () => {
    downloadPDF(pdfLink);
  }
  
  const showModal = () => {
    setShowEmailModal(true);
  }

  return (
    <div className="summary-actions">
      <div className="summary-buttons">
        {/* <button className="swt-button summary-other">Other button</button> */}
        <button onClick={backToStart} className="swt-button summary-restart">{matrixData['restartButtonText']}</button>
      </div>

      <div className="summary-save">
        <button disabled={printAndEmailReady} onClick={printThisPage} className="summary-print">
          <ExportPrint />
          <div>Print this page</div>
        </button>
        <button onClick={showModal} className="summary-email" disabled={printAndEmailReady}>
          <ExportMail />
          <div>Email this page</div>
        </button>
      </div>
    </div>
  )
}

SummaryActions.propTypes = {}

export default SummaryActions